<div class="dialog-header">
  <div class="dialog-title">
    <h1>
      {{ id ? ("editUser" | translate) : ("newUser" | translate) }}
    </h1>
  </div>

  <a href="javascript:;" class="dialog-close" (click)="close()"
    ><i class="fal fa-times"></i
  ></a>
</div>

<div class="dialog-content">
  <nz-spin [nzSpinning]="isLoading">
    <form nz-form nzLayout="vertical" [formGroup]="form" (submit)="save()">
      <nz-form-item>
        <nz-form-label nzFor="name" nzRequired>{{
          "name" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="name"
            id="name"
            [placeholder]="'name' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="note">{{
          "note" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="note"
            id="note"
            [placeholder]="'note' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="dateOfBirth">{{
          "dateOfBirth" | translate
        }}</nz-form-label>
        <nz-form-control>
          <nz-date-picker
            formControlName="dateOfBirth"
            id="dateOfBirth"
            [nzPlaceHolder]="'dateOfBirth' | translate"
          ></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="email">{{
          "email" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="email"
            id="email"
            [placeholder]="'email' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="phone">{{
          "phone" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="phone"
            id="phone"
            [placeholder]="'phone' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="sex">{{
          "gender" | translate
        }}</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="sex">
            <nz-option
              [nzValue]="SexEnum.Female"
              [nzLabel]="'female' | translate"
            ></nz-option>
            <nz-option
              [nzValue]="SexEnum.Male"
              [nzLabel]="'male' | translate"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>


      <nz-form-item>
        <nz-form-label nzFor="joined">{{
          "joined" | translate
        }}</nz-form-label>
        <nz-form-control>
          <nz-date-picker
            formControlName="joined"
            id="joined"
            [nzPlaceHolder]="'joined' | translate"
            [nzDisabledDate]="disabledEndDate"
          ></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <div class="mt-4">
        <button nz-button nzType="primary" type="submit" [nzLoading]="isSaving">
          {{ id ? ("saveChanges" | translate) : ("add" | translate) }}
        </button>
        <button
          nz-button
          (click)="close()"
          type="button"
          class="ml-2"
          [disabled]="isSaving"
        >
          {{ "cancel" | translate }}
        </button>
      </div>
    </form>
  </nz-spin>
</div>
